import React, { useState, MouseEvent, useEffect, useRef } from "react";
import ConfirmModal from "../ConfirmModal";
import { ConfirmPrintPubSub, ConfirmPrintPubSubPayload } from "@utils/pubsubs/PubSub";
import { useAppSelector } from "@/store/hooks";
import { TICKET_PRINT_FORMANT_ID } from "@utils/Constants";

export type DocumentPrintConfirmationProps = {
  onConfirm?: (e: MouseEvent<HTMLButtonElement>) => void;
  title: string;
  confirmMessage?: string;
  confirmBtnText?: string;
  primaryBtnColor?: string;
  secondaryBtn?: string;
  secondaryBtnColor?: string;
};

const DocumentPrintConfirmation: React.FC<DocumentPrintConfirmationProps> = ({
  title = "",
  confirmMessage = "El documento fue creado exitosamente, desea imprimirlo?",
  confirmBtnText,
  primaryBtnColor,
  secondaryBtn,
  secondaryBtnColor
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const suscriptionData = useAppSelector(state => state.suscription.suscription)
  const [printVersionUrl, setPrintVersionUrl] = useState<string>("");
  const [extraPrintUrls, setExtraPrintUrls] = useState<string[]>([]);
  const ticketPrintRef = useRef<() => void | null>(null!);

  /** Abre el documento principal y los que lo acompanan (formato carta). */
  const openPrintUrls = (mainUrl?: string, extraUrls: string[] = []) => {
    if (mainUrl) {
      window.open(mainUrl, '_blank')
    }
    extraUrls.forEach((url) => window.open(url, '_blank'))
  }

  useEffect(() => {

    const unsubscribe = ConfirmPrintPubSub.subscribe(openConfirmation);
    return () => {
      unsubscribe();
    };
  }, [])

  const openConfirmation = (payload: ConfirmPrintPubSubPayload) => {
    const { openOffCanvas, printVersionUrl, extraPrintUrls = [], ticketPrintCallBack } = payload;
    ticketPrintRef.current = typeof ticketPrintCallBack === 'function' ? ticketPrintCallBack : () => { };

    if (suscriptionData?.auto_print) {
      if (suscriptionData?.formato_impresion === TICKET_PRINT_FORMANT_ID) {
        ticketPrintRef.current?.();
      } else {
        openPrintUrls(printVersionUrl, extraPrintUrls)
      }
    } else {
      setIsOpen(openOffCanvas);
      setPrintVersionUrl(`${printVersionUrl}`);
      setExtraPrintUrls(extraPrintUrls);
    }
  }

  const triggerConfirm = (e: MouseEvent<HTMLButtonElement>) => {
    if (suscriptionData?.formato_impresion === TICKET_PRINT_FORMANT_ID) {
      ticketPrintRef.current?.();
    } else {
      openPrintUrls(printVersionUrl, extraPrintUrls)
    }

    setIsOpen(false)
  };

  const toggleModal = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <>
      <ConfirmModal
        toggle={toggleModal}
        isOpen={isOpen}
        title={title}
        onConfirm={triggerConfirm}
        primaryBtn={confirmBtnText}
        primaryBtnColor={primaryBtnColor}
        secondaryBtn={secondaryBtn}
        secondaryBtnColor={secondaryBtnColor}
      >
        {confirmMessage}
      </ConfirmModal>
    </>
  );
};

export default DocumentPrintConfirmation;
